import { render, staticRenderFns } from "./MailSegnalazioneShadow.vue?vue&type=template&id=21bd5c1a&scoped=true"
import script from "./MailSegnalazioneShadow.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneShadow.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneShadow.vue?vue&type=style&index=0&id=21bd5c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd5c1a",
  null
  
)

export default component.exports